var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-file",
    clipPath: "url(#clip0_1050_30609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.06973 15.4411C7.06973 15.0425 6.79316 14.8048 6.30519 14.8048C6.10592 14.8048 5.97098 14.8245 5.90039 14.8433V16.1221C5.98397 16.1409 6.08671 16.1472 6.22833 16.1472C6.74846 16.1472 7.06973 15.8844 7.06973 15.4411Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0907 14.8182C9.87221 14.8182 9.73099 14.8371 9.64746 14.8567V17.6888C9.73104 17.7085 9.86599 17.7085 9.98799 17.7085C10.8745 17.7147 11.4527 17.2267 11.4527 16.1928C11.4589 15.2936 10.9321 14.8182 10.0907 14.8182Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.703 0.000244141H6.06363C4.65541 0.000244141 3.50927 1.14718 3.50927 2.55461V12.0002H3.25978C2.69141 12.0002 2.23047 12.4607 2.23047 13.0296V19.2719C2.23047 19.8407 2.69136 20.3012 3.25978 20.3012H3.50927V21.4458C3.50927 22.8548 4.65541 24.0002 6.06363 24.0002H19.2161C20.6235 24.0002 21.7698 22.8548 21.7698 21.4458V6.04574L15.703 0.000244141ZM4.93078 14.1561C5.23243 14.1051 5.65644 14.0667 6.25383 14.0667C6.85754 14.0667 7.28782 14.1819 7.57693 14.4134C7.8531 14.6315 8.03947 14.9916 8.03947 15.4153C8.03947 15.8389 7.89825 16.199 7.6413 16.443C7.30709 16.7576 6.81284 16.8988 6.23467 16.8988C6.10599 16.8988 5.99065 16.8924 5.90046 16.8799V18.4278H4.93078V14.1561ZM19.2161 22.4359H6.06363C5.51836 22.4359 5.07434 21.9918 5.07434 21.4458V20.3012H17.3352C17.9036 20.3012 18.3645 19.8407 18.3645 19.2719V13.0296C18.3645 12.4607 17.9036 12.0002 17.3352 12.0002H5.07434V2.55461C5.07434 2.01013 5.51841 1.56611 6.06363 1.56611L15.1178 1.55666V4.90338C15.1178 5.88093 15.9109 6.67484 16.8892 6.67484L20.1677 6.66543L20.2046 21.4458C20.2046 21.9918 19.7614 22.4359 19.2161 22.4359ZM8.66473 18.4082V14.1561C9.02438 14.0988 9.49314 14.0667 9.98783 14.0667C10.81 14.0667 11.3431 14.2142 11.7608 14.5287C12.2104 14.8629 12.4928 15.3957 12.4928 16.1605C12.4928 16.989 12.1911 17.5609 11.7733 17.9139C11.3175 18.2928 10.6236 18.4725 9.77598 18.4725C9.26834 18.4725 8.90869 18.4403 8.66473 18.4082ZM15.6748 15.8907V16.6869H14.1203V18.4278H13.1376V14.0988H15.7838V14.9014H14.1203V15.8907H15.6748Z",
    fill: "#F5222D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_30609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePdf);
export default __webpack_public_path__ + "static/media/icon-file-pdf.72aa275bcbb65b19af78bd1582aa24c9.svg";
export { ForwardRef as ReactComponent };